module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/d0289dc0a46fc5b15b3363ffa78cf6c7.png";